import { Container } from "react-bootstrap";

const PoliticaPrivacidad = () => {
    return (
        <Container className="my-5">
            <h1>Política de Privacidad</h1>

            <section className="mt-4">
                <h4>1. OBJETO</h4>
                <p>
                    Esta Política de Privacidad tiene por objeto dar a conocer cómo recabo, trato y protejo los datos personales que usted, como usuario, me ha facilitado mediante este sitio web (en adelante, Sitio Web), y decidir libremente si desea que los trate. Asimismo, cumple con el Reglamento General de Protección de Datos (RGPD 2016/679) y la Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de Derechos Digitales (LOPDGDD).
                </p>
            </section>

            <section className="mt-4">
                <h4>2. IDENTIFICACIÓN DEL RESPONSABLE</h4>
                <ul>
                    <li style={{ textAlign: "left" }}><strong>Nombre / Razón social:</strong> Matias Alessandro Contreras</li>
                    <li style={{ textAlign: "left" }}><strong>NIF:</strong> X3829511B</li>
                    <li style={{ textAlign: "left" }}><strong>Domicilio social:</strong> Calle Asarau 20 1º B, 12001 Castellón</li>
                    <li style={{ textAlign: "left" }}><strong>Correo electrónico:</strong> No disponible</li>
                    <li style={{ textAlign: "left" }}><strong>Teléfono:</strong> 621 06 10 16</li>
                    <li style={{ textAlign: "left" }}><strong>Nombre de dominio:</strong> manusfortis.es</li>
                    <li style={{ textAlign: "left" }}><strong>Actividad:</strong> Centro de masajes</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>3. TRATAMIENTO DE DATOS PERSONALES</h4>
                <p>
                    Los datos personales que me facilite mediante formularios de contacto, correo electrónico u otros medios serán tratados de forma confidencial y únicamente por personal autorizado. Todas las categorías y tipos de datos tratados estarán debidamente identificados en las correspondientes actividades de tratamiento.
                </p>
            </section>

            <section className="mt-4">
                <h4>4. FINALIDAD</h4>
                <p>
                    El tratamiento de datos tiene como finalidad mantener la relación con clientes, proveedores y usuarios, atendiendo solicitudes de información, quejas o reclamaciones, así como cumplir obligaciones contractuales, legales o comerciales. No se envía publicidad sin consentimiento previo, salvo a clientes con relación vigente respecto a los servicios prestados.
                </p>
            </section>

            <section className="mt-4">
                <h4>5. LEGITIMACIÓN</h4>
                <p>El tratamiento de sus datos se realiza sobre las siguientes bases:</p>
                <ul>
                    <li style={{ textAlign: "left" }}>Consentimiento expreso y voluntario del interesado.</li>
                    <li style={{ textAlign: "left" }}>Cumplimiento de la relación comercial o contractual.</li>
                    <li style={{ textAlign: "left" }}>Cumplimiento de obligaciones legales.</li>
                    <li style={{ textAlign: "left" }}>En caso de menores de 14 años, se requiere consentimiento de padres o tutores.</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>6. CONSERVACIÓN DE DATOS</h4>
                <p>
                    Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad de su tratamiento y para cumplir obligaciones legales. En solicitudes de empleo, se conservarán como máximo 1 año o hasta que el interesado solicite su supresión.
                </p>
            </section>

            <section className="mt-4">
                <h4>7. ELABORACIÓN DE PERFILES</h4>
                <p>
                    No se elaboran perfiles automatizados con sus datos, salvo que se informe y se solicite autorización previa.
                </p>
            </section>

            <section className="mt-4">
                <h4>8. CESIÓN DE DATOS</h4>
                <p>
                    Por norma general, no se ceden datos a terceros, salvo casos necesarios para prestar servicios contratados, cumplir obligaciones legales o delegar funciones a proveedores autorizados mediante contrato de encargado de tratamiento. En caso de transferencias fuera del EEE, se solicitará consentimiento previo.
                </p>
            </section>

            <section className="mt-4">
                <h4>9. MEDIDAS DE SEGURIDAD</h4>
                <p>
                    Se aplican medidas técnicas y organizativas para proteger los datos personales, evitando pérdida, robo o uso no autorizado, adaptadas al tipo de datos y finalidades del tratamiento.
                </p>
            </section>

            <section className="mt-4">
                <h4>10. DERECHOS DE LOS INTERESADOS</h4>
                <p>
                    Usted puede acceder, rectificar, suprimir, limitar o portar sus datos, así como revocar el consentimiento y oponerse al tratamiento. Para ejercer sus derechos, escriba a <strong>matiascontr@gmail.com</strong> incluyendo copia de DNI u otro documento equivalente. Menores de 14 años deben actuar a través de padres o tutores.
                </p>
                <p>
                    También puede contactar con <strong>matiascontr@gmail.com</strong> para consultas sobre tratamiento de datos. Asimismo, tiene derecho a presentar reclamación ante la Agencia Española de Protección de Datos: <em>C/Jorge Juan, 6, 28001 Madrid</em> o en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.
                </p>
            </section>

            <section className="mt-4">
                <h4>11. COMPROMISO CON LA PROTECCIÓN DE DATOS PERSONALES</h4>
                <ul>
                    <li style={{ textAlign: "left" }}><strong>Ámbito de aplicación:</strong> Cumplimiento obligatorio de la normativa en todo momento.</li>
                    <li style={{ textAlign: "left" }}><strong>Objeto:</strong> Protocolos de actuación para garantizar la protección de datos.</li>
                    <li style={{ textAlign: "left" }}><strong>Principios:</strong> Licitud, Lealtad, Transparencia, Minimización, Exactitud, Limitación del plazo, Integridad, Confidencialidad y Responsabilidad activa.</li>
                    <li style={{ textAlign: "left" }}><strong>Categoría especial de datos:</strong> No se tratan datos sensibles salvo con consentimiento expreso.</li>
                    <li style={{ textAlign: "left" }}><strong>Derechos:</strong> Acceso, rectificación, supresión, limitación, portabilidad y oposición al tratamiento.</li>
                    <li style={{ textAlign: "left" }}><strong>Registro y control:</strong> Registro de actividades de tratamiento y medidas de seguridad para garantizar confidencialidad, integridad y disponibilidad.</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>12. ACTUALIZACIÓN DE ESTA POLÍTICA</h4>
                <p>
                    Esta política puede modificarse sin previo aviso, por lo que se recomienda revisarla periódicamente. Actualizado el 19 de mayo de 2025.
                </p>
                <p>
                    Esta política refleja el compromiso con la protección de sus datos y cumplimiento de la normativa vigente.
                </p>
            </section>
        </Container>
    );
};

export default PoliticaPrivacidad;
